export default __webpack_public_path__ + "static/media/homefresh.0d7caaec.png";